import React, { Component } from "react"
import PropTypes from "prop-types"
import Input from "../input/Input"

import { buildFormControllClass } from "../../helpers/formUtils"

class FieldGroupName extends Component {
  constructor(props) {
    super(props)

    this.state = {
      values: { first: "", last: "" },
      validity: { first: true, last: true },
    }

    this.onNameChange = this.onNameChange.bind(this)
    this.onNameFocusOut = this.onNameFocusOut.bind(this)
  }

  onNameChange(nameId, value) {
    const { values } = this.state
    const { id, onChange } = this.props

    values[nameId] = value
    onChange(id, values)

    this.setState(values)
  }

  onNameFocusOut(nameId, el) {
    const { validity } = this.state
    const { id, onFocusOut } = this.props

    validity[nameId] = el.checkValidity()
    this.setState(validity)

    onFocusOut(id, validity.first && validity.last)
  }

  getNamesFromValues() {
    const { value } = this.props

    return {
      firstName: value.first || "",
      lastName: value.last || "",
    }
  }

  render() {
    const { className, label, hide_label, hidden, required, disable } =
      this.props
    const { firstName, lastName } = this.getNamesFromValues()
    const { validity } = this.state

    return (
      <div
        className={`form-control${buildFormControllClass(
          className,
          hidden,
          required,
          true,
          disable
        )}`}
      >
        {label && !hide_label && (
          <span
            className="form-control__label"
            dangerouslySetInnerHTML={{ __html: label }}
          />
        )}
        <div className="grid grid--gutters-xsm">
          <div className="grid__col grid__col--1-2">
            <Input
              id="first"
              type="text"
              label="First Name"
              value={firstName}
              required={required}
              onChange={this.onNameChange}
              onFocusOut={this.onNameFocusOut}
              disable={disable}
              isValid={validity.first}
            />
          </div>

          <div className="grid__col grid__col--1-2">
            <Input
              id="last"
              type="text"
              label="Last Name"
              value={lastName}
              required={required}
              onChange={this.onNameChange}
              onFocusOut={this.onNameFocusOut}
              disable={disable}
              isValid={validity.last}
            />
          </div>
        </div>
      </div>
    )
  }
}

FieldGroupName.defaultProps = {
  id: "",
  label: "",
  hidden: false,
  hide_label: false,
  name: "",
  readonly: false,
  required: false,
  value: "",
  onChange: () => {},
  onFocusOut: () => {},
}

FieldGroupName.propTypes = {
  id: PropTypes.string,
  label: PropTypes.string,
  hidden: PropTypes.bool,
  hide_label: PropTypes.bool,
  name: PropTypes.string,
  readonly: PropTypes.bool,
  required: PropTypes.bool,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({
      first: PropTypes.string,
      last: PropTypes.string,
    }),
  ]),
  onChange: PropTypes.func,
  onFocusOut: PropTypes.func,
}

export default FieldGroupName
